import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-total-debt-with-current-account-badge',
  templateUrl: './customer-total-debt-with-current-account-badge.component.html',
  styleUrls: ['./customer-total-debt-with-current-account-badge.component.css']
})
export class CustomerTotalDebtWithCurrentAccountBadgeComponent implements OnInit {

  @Input() balance: number;
  @Input() totalDebt: number;
  @Input() currentAccountBalance: number;
  @Input() showLabel: boolean = true;
  constructor() { }

  ngOnInit(): void {
  }


}
